export default __webpack_public_path__ + "static/patt-light-cb9b5d8cfb35356e6f5c459cef13d7c5.jpg";